import React, { Suspense, lazy } from "react"
import type { RouteObject } from "react-router-dom"

import ProtectedRoute from "@components/layout/ProtectedRoute"
import AppLayout from "@components/layout/App.layout"
import ProtectedSuperAdmin from "@src/components/layout/ProtectedSuperAdmin"
import ErrorBoundary from "@pages/ErrorBoundary"
import { PageLoader } from "@components/ui"

const LegacyProfilesPage = lazy(() => import("@pages/LegacyProfiles/LegacyProfiles.page"))
const ConversationsPage = lazy(() => import("@pages/Conversations.page"))
const ProfilePage = lazy(() => import("@pages/Profile/Profile.page"))
const DashboardPage = lazy(() => import("@pages/Dashboard.page"))
const QuestionsPage = lazy(() => import("@pages/Questions/Questions.page"))
const MessagesPage = lazy(() => import("@pages/Messages.page"))
const SettingsPage = lazy(() => import("@pages/Settings/Settings.page"))
const MediaPage = lazy(() => import("@pages/Media/Media.page"))
const ChatPage = lazy(() => import("@pages/Chat/Chat.page"))
const UsersPage = lazy(() => import("@pages/Users/Users.page"))
const NotificationsPage = lazy(() => import("@pages/Notifications/Notifications.page"))
const EmailInboxPage = lazy(() => import("@pages/Email/EmailInbox.page"))

export const AppRouter: RouteObject[] = [
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <ErrorBoundary>
          <AppLayout />
        </ErrorBoundary>
      </ProtectedRoute>
    ),
    children: [
      {
        path: "/dashboard",
        element: (
          <Suspense fallback={<PageLoader text="Loading dashboard..." />}>
            <DashboardPage />
          </Suspense>
        ),
      },
      {
        path: "/users",
        element: (
          <ProtectedSuperAdmin>
            <Suspense fallback={<PageLoader text="Loading users..." />}>
              <UsersPage />
            </Suspense>
          </ProtectedSuperAdmin>
        ),
      },
      {
        path: "/legacy-profiles",
        element: (
          <Suspense fallback={<PageLoader text="Loading legacy profiles..." />}>
            <LegacyProfilesPage />
          </Suspense>
        ),
      },
      {
        path: "/questions",
        element: (
          <Suspense fallback={<PageLoader text="Loading questions..." />}>
            <QuestionsPage />
          </Suspense>
        ),
      },
      {
        path: "/conversations",
        element: (
          <Suspense fallback={<PageLoader text="Loading conversations..." />}>
            <ConversationsPage />
          </Suspense>
        ),
      },
      {
        path: "/messages",
        element: (
          <Suspense fallback={<PageLoader text="Loading messages..." />}>
            <MessagesPage />
          </Suspense>
        ),
      },
      {
        path: "/chat",
        element: (
          <Suspense fallback={<PageLoader text="Loading chat..." />}>
            <ChatPage />
          </Suspense>
        ),
      },
      {
        path: "/media",
        element: (
          <Suspense fallback={<PageLoader text="Loading media..." />}>
            <MediaPage />
          </Suspense>
        ),
      },
      {
        path: "/settings",
        element: (
          <Suspense fallback={<PageLoader text="Loading settings..." />}>
            <SettingsPage />
          </Suspense>
        ),
      },
      {
        path: "/profile",
        element: (
          <Suspense fallback={<PageLoader text="Loading profile..." />}>
            <ProfilePage />
          </Suspense>
        ),
      },
      {
        path: "/notifications",
        element: (
          <Suspense fallback={<PageLoader text="Loading notifications..." />}>
            <NotificationsPage />
          </Suspense>
        ),
      },
      {
        path: "/email",
        element: (
          <Suspense fallback={<PageLoader text="Loading email inbox..." />}>
            <EmailInboxPage />
          </Suspense>
        ),
      },
    ],
  },
]
